export const KYC_VERIFICATION = '/kyc-verification/kycVerificationStatus'
